import { invokeApi } from "../invokeApi";

export const _Website_Settings_List = async (data) => {
  const requestObj = {
    path: `/api/website_settings/list_website_settings`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data || {},
  };
  return invokeApi(requestObj);
};

export const _Website_Settings_List_Update = async (data) => {
  const requestObj = {
    path: `/api/website_settings/update_website_settings`,
    method: "PUT",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data || {},
  };
  return invokeApi(requestObj);
};
